module.exports = __webpack_public_path__ + "img/logo-w-container.563de239.svg";